import React from 'react';

import RootStack from '../RootStack';

import ExportStories from '../../containers/export/stories/Index';
import ExportStory from '../../containers/export/stories/Show';
import ExportEpisode from '../../containers/export/episodes/Show';

const ProOnlyScreens = (
  <>
    <RootStack.Screen
      name="ExportStories"
      component={ExportStories}
      options={{title: 'エクスポートするストーリーを選択'}}
    />
    <RootStack.Screen
      name="ExportStory"
      component={ExportStory}
      options={{title: 'エクスポートするエピソードを選択'}}
    />
    <RootStack.Screen
      name="ExportEpisode"
      component={ExportEpisode}
      options={{title: 'エクスポート形式'}}
    />
  </>
);

export default ProOnlyScreens;
